<template>
  <page-header-wrapper>
    <div class="back-content">
      <a-tabs
        class="back-content-tabs"
        :default-active-key="selectedTab"
        :active-key="selectedTab"
        :animated="false"
        @change="tabChange"
      >
        <a-tab-pane
          v-for="tab in tabs"
          :key="tab.key"
          :tab="tab.title"
        >
          <component :is="tab.component" />
        </a-tab-pane>
      </a-tabs>
    </div>
  </page-header-wrapper>
</template>

<script>
import BaseInfo from './baseInfo/BaseInfo.vue'
// import ContractInfo from './contractInfo/ContractInfo.vue'

const settingTabs = [
  {
    title: '基地信息',
    key: 'baseInfo',
    component: 'BaseInfo'
  }
  // {
  //   title: '合同信息',
  //   key: 'contractInfo',
  //   component: 'ContractInfo'
  // }
]

export default {
  components: {
    BaseInfo
    // ContractInfo
  },
  data () {
    return {
      tabs: settingTabs,
      selectedTab: ''
    }
  },
  watch: {
    '$route.query.tab': {
      handler: function (val) {
        this.setSelectedTab()
      }
    }
  },
  created () {
    this.setSelectedTab()
  },
  methods: {
    setSelectedTab () {
      if (this.$route.query && this.$route.query.tab) {
        this.selectedTab = this.$route.query.tab
      } else {
        this.selectedTab = this.tabs[0].key
      }
    },
    tabChange (activeKey) {
      this.$router.push({
        name: 'base',
        query: {
          tab: activeKey
        }
      })
    }
  }
}
</script>
